import React, { useEffect, useState } from 'react'
import classes from "../UserDetails/style.module.scss";
import ScrollableTable from '../../../../component/ScrollableTable';
import { Icons } from '../../../../assets';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { Toast } from '../../../../service/toast';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';

const AuthorizedUser = (props) => {

    const { userData } = props
    const dispatch = useDispatch();
    const [retailerId, setRetailerId] = useState(null);
    const [userList, setUserList] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [sortedColumns, setSortedColumns] = useState(null);
    const [showDeletePopUp, setShowDeletePopUp] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [selectedRoleId, setSelectedRoleId] = useState(null)

    const userHeader = [
        { label: 'Authorised Users', sortable: 'name' },
        { label: 'Mobile number' },
        { label: 'Email' },
        { label: 'Action' }
    ];

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const idParam = searchParams.get('id');
        setRetailerId(idParam);
    }, []);

    useEffect(() => {
        if (sortedColumns) {
            let tableData = Object.assign([], userList)
            if (sortedColumns?.direction === 'desc') {
                tableData = tableData?.sort((a, b) => b[sortedColumns?.key]?.localeCompare(a[sortedColumns?.key]));
            } else {
                tableData = tableData?.sort((a, b) => a[sortedColumns?.key]?.localeCompare(b[sortedColumns?.key]));
            }
            setUserList(tableData)
        } else {
            setUserList(userList)
        }
    }, [sortedColumns])

    const getUserList = async () => {      
        setisLoading(true)  
        setUserList(userData)
        setisLoading(false)  
    }

    useEffect(() => {
        getUserList()
    }, [])

    const handleTableData = (keyValue, defaultValue, className = '') => {
        return (
            <div className={`${className} w-[50%]`}>{keyValue ? keyValue : defaultValue}</div>
        )
    };

    const handleDelete = (id, roleId) => {
        setShowDeletePopUp(true)
        setSelectedId(id)
        setSelectedRoleId(roleId)
    };

    const deleteProduct = async () => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.commonAuthUser}?r_id=${selectedId}&retailer_id=${retailerId}`
        const requestData = {
            r_id: selectedId,
            retailer_id: retailerId
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                setShowDeletePopUp(false)
                Toast({
                    type: 'success',
                    message: 'Record deleted successfully!...'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleClose = () => {
        setShowDeletePopUp(false)
    }
    
    return (
      <div className={`${classes.userCardWrapper} mb-4`}>
        <div className={`${classes.informationTitle}`}>Authorized Users</div>

        <div className={`my-5 scrollTableWrapper`}>
          <ScrollableTable
            headerDetails={userHeader}
            listLength={userList || []}
            isLoading={isLoading}
            tableSort
            sortedColumns={sortedColumns}
            setSortedColumns={setSortedColumns}
            autoHeight
          >
            {userList?.map((item, index) => {
              const {
                name = "",
                email = "",
                mobileNumber = "",
                authorized_user_id = "",
              } = item;
              return (
                <div
                  className={`flex items-center rowTableData `}
                  key={authorized_user_id}
                >
                  {handleTableData(name, "-", "text-center")}
                  {handleTableData(mobileNumber, "-", "text-center")}
                  {handleTableData(email, "-", "text-center")}
                  <div
                    className={`delete w-[50%]`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={Icons?.delete}
                      alt="delete"
                      onClick={() => handleDelete(authorized_user_id)}
                    />
                  </div>
                </div>
              );
            })}
          </ScrollableTable>
        </div>
        {showDeletePopUp ? (
          <ConfirmationModal
            isOpen={showDeletePopUp}
            handleSuccess={deleteProduct}
            closePopUp={handleClose}
            warningText={"Confirmation"}
            modalText={"Are you sure you want to delete this user?"}
            confirmText={"Yes"}
            cancelText={"No"}
            primaryBtnConfirm={false}
          />
        ) : null}
      </div>
    );
}

export default AuthorizedUser